import React, { useEffect, useState,Fragment, memo } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { obtenerLiquidacionPerdida } from '../../../../store/actions/caso-general-action'
import GrillaPerdidaParcial from './GrillaPerdidaParcial'
import LiquidacionParcial from './LiquidacionParcial'
import LiquidacionTotal from './LiquidacionPerdidaTotal'


const Liquidacion = memo(({tipo}) => {
  const [loading, setLoading]=useState(false)
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form, antecedentesCasos,llaves } = data_datos_generales
  const [datosSiniestro, setDatosSiniestro] = useState({})
  
    // El hook useDispatch (redux) permite invocar una action.
    const dispatch = useDispatch();
  useEffect(() => {
    
    if(llaves){
setLoading(true)
      if(antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']===15005){
        let query = Buffer.from(JSON.stringify({
          "idCaso": llaves["idCaso"],
          "idImplicado":0,
          "idOrganizacion": llaves["idOrgCaso"],
          "tipoGestion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoGestion'],
          "tipoSiniestro": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']
        })).toString('base64');
        dispatch(obtenerLiquidacionPerdida(query)).then(()=>setLoading(false));
      }if(antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']===15001){
        setLoading(true)
        let query = Buffer.from(JSON.stringify({
          "idCaso": llaves["idCaso"],
          "idImplicado": 0,//llaves["idImplicado"],
          "idOrganizacion": llaves["idOrgCaso"],
          "tipoGestion": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoGestion'],
          "tipoSiniestro": antecedentesCasos && antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']
        })).toString('base64');
        dispatch(obtenerLiquidacionPerdida(query)).then(()=>setLoading(false));
      }
    }
   

}, [antecedentesCasos, llaves]);
  return (
      <>
    
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#D9EDF6", color:"#8578CD"}}>
        {cfg_form && antecedentesCasos ? (antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']===15005? cfg_form.cfg_form['gestcasosrecup-tab-liqasegpp-title']:cfg_form.cfg_form['gestcasosrecup-tab-liqasegpt-title']) : null}
      </Card.Header>
      <Container >
    

        {cfg_form && antecedentesCasos  ? (antecedentesCasos.antecedentesCasos[0]['IdTipoSiniestro']===15005 ?
       
        <>

        <LiquidacionParcial/>
         <GrillaPerdidaParcial/> 
        </>
        :<LiquidacionTotal/>
       ):
         null}
   
      </Container>
    </Card>


    </>
  )
})

export default Liquidacion


